import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { ImbeeChatVariables } from '../imbee-chat/imbee-chat-utils';
import ImbeeChat from '../imbee-chat/ImbeeChat';
import { showModal } from '../../store/slices/generalSlice';
import { ContentLayout } from '../../global-styles/layout';

const ChatContact = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(showModal({ name: 'imbee-chat' }));
  }, [dispatch]);

  const chatVariables: ImbeeChatVariables = [['pantalla', 'contactoHayExpediente']];

  return (
    <ContentLayout data-cy="fullscreen-imbee-page">
      <ImbeeChat hideCloseButton chatVariables={chatVariables} />
    </ContentLayout>
  );
};

export default ChatContact;
